exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".colwidth{min-width:200px!important}a:not(.md-button):not(.md-bottom-bar-item):hover{text-decoration:none!important}.status-alerts{font-size:11px;flex-direction:column}@keyframes blinker{50%{opacity:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-556af95c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ledgerOutstanding/outstanding.vue
// module id = 1614
// module chunks = 0